<button mat-icon-button (click)="toggleNotifications(); $event.stopPropagation();">
  <mat-icon *ngIf="!hasNotifications">notifications_none</mat-icon>
  <mat-icon *ngIf="hasNotifications" color="accent">notifications</mat-icon>
</button>